import { Award03, Dataflow01 } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

import MoodWrapper from "./user/components/MoodWrapper";

export default {
  name: "mood",
  priority: 8,
  icon: Award03,
  wrapper: {
    user: MoodWrapper,
  },
  menu: ({ t }: { t: TFunction }) => ({
    user: [],
    admin: [
      {
        label: t("Mood", { ns: "mood.shared" }),
        icon: <Award03 />,
        to: "/admin/mood",
        permission: "mood.mood.view",
      },
    ],
    settings: [
      {
        label: t("Mood", { ns: "mood.shared" }),
        icon: <Dataflow01 />,
        to: "/admin/settings/mood",
        permission: "mood.mood-settings.view",
      },
    ],
  }),
} satisfies ModuleData;
